import { CdkVirtualScrollViewport, FixedSizeVirtualScrollStrategy, VirtualScrollStrategy } from '@angular/cdk/scrolling';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Injectable } from "@angular/core";

export interface SwiperScrollOptions {
    itemSize: number;       // Size of scroll item
    minBufferPx: number;    // Minimum item view buffer size to render from beginning
    maxBufferPx: number;    // Maximum item view buffer size to render at the same time
};

/**
 * Virtual scroll strategy enabling scroll to center of the default Fixed Size Angular Virtual Scroll Strategy 
 */
@Injectable()
export class SwiperScrollStrategy extends FixedSizeVirtualScrollStrategy implements VirtualScrollStrategy {
    private itemSize: number;
    private minBuffer: number;
    private maxBuffer: number;
    private viewport: CdkVirtualScrollViewport = null;

    constructor() {
        // Initialize fixed strategy with std. values (will be overwritten on init)
        super(460, 460 * 4, 460 * 8);
    }
    private idxChangeSubject = new Subject<number>();
    // Overwrite scroll change event from virtual scroll viewport
    public scrolledIndexChange: Observable<number> = this.idxChangeSubject.pipe();

    public init(options: SwiperScrollOptions) {
        this.itemSize = options.itemSize;
        this.minBuffer = options.minBufferPx;
        this.maxBuffer = options.maxBufferPx;
        super.updateItemAndBufferSize(this.itemSize, this.minBuffer, this.maxBuffer);
    }

    attach(viewport: CdkVirtualScrollViewport): void {
        super.attach(viewport);
        this.viewport = viewport;
    }

    detach(): void {
        super.detach();
    }

    onContentScrolled(): void {
        if(!this.itemSize) return;
        // Notify super to change visible entries
        super.onContentScrolled();
        // Find scrolled offset and add half item size to target center of item 
        let offset = this.viewport.measureScrollOffset() + (this.itemSize / 2);
        // Find the item to be highlighted (currently scrolled to)
        let idx = Math.round((offset + this.itemSize / 2) / this.itemSize) - 1;
        // Send item highlight change event 
        this.idxChangeSubject.next(idx);
    }

    scrollToIndex(index: number, behavior: ScrollBehavior): void {
        super.scrollToIndex(index, behavior);
    }
}
